<template>
  <div class="mr-10">
    <v-card flat class="mt-5">
      <v-card-title>
        <h6 class="primary--text">Liste des logs</h6>
        <v-spacer></v-spacer>
      </v-card-title>
    </v-card>

    <v-data-table :headers="headers" :items="sessions" :loading="loading" loading-text="Loading..."
      :page.sync="currentPage" :server-items-length="totalItems" :items-per-page.sync="rowsPerPage"
      :footer-props="footerProps" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon small @click="showSession(item)">
          mdi-eye-outline
        </v-icon>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'sessions-page',
  mixins: [Permissions],
  data: () => ({
    loading: false,
    search: '',
    headers: [
      { text: 'Utilisateur', value: 'causer.email' },
      { text: 'Description', value: 'description' },
      { text: 'Adresse IP', value: 'log_name' },
      { text: 'Date', value: 'created_at' }
    ],
    footerProps: {
      "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
      "items-per-page-text": "Lignes par page",
    },
    payload: { page: 1, size: 15 },
  }),

  created() {
    this.$checkPermission('access sessions')
    this.fetchUtils();
  },

  computed: {
    sessions() { return this.$store.getters.sessions.data; },
    totalItems() {
      return this.$store.getters.sessions.total;
    },
    rowsPerPage: {
      get: function () {
        return this.$store.getters.sessions.per_page;
      },

      set: function (value) {
        const old = this.payload.size 
        this.payload.size  = value;
        if (old != this.payload.size ) this.fetchUtils();
      },
    },
    currentPage: {
      get: function () {
        return this.$store.getters.sessions.current_page;
      },

      set: function (value) {
        const old = this.payload.page
        this.payload.page = value;
        if (old != this.payload.page) this.fetchUtils();
      },
    },
  },

  methods: {
    async fetchUtils() {
      this.loading = true;
      await this.$store.dispatch("fetchSessions", this.payload);
      this.loading = false;
    },
    showSession(item) {
      console.log(item);
    }
  }
};
</script>

<style scoped>
.couleur-orange {
  color: rgb(255, 152, 0);

  font-size: 1.2em;
}

.white-couleur {
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/sessions/index.vue